var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","color":"tertiary","max-width":"300"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_vm._t("content",[_c('v-btn',{attrs:{"color":"primary","small":"","rounded":""}},[_c('v-icon',[_vm._v("mdi-book")])],1)])],2)]}}],null,true)},[_c('span',{staticClass:"black--text"},[_vm._t("tooltip-content",[_vm._v("Tooltip Content")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }